import React, { useState, useEffect } from "react";
import "./RegisterForm.css";
import { BASE_URL } from "../../../api";
import {useNavigate } from "react-router-dom";
import ReactGA from 'react-ga4';

function MultiHorizontalStepper() {
  const [activeStep, setActiveStep] = useState(0);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [statename, setStatename] = useState();
  const navigate = useNavigate();


  const [stateNames, setStateNames] = useState({});

  const [formValues, setFormValues] = useState({
    fullName: "",
    mobileNumber: "",
    dateofBirth: "",
    schoolName: "",
    state: "",
    district: "",
    address: "",
    email: "",
    palyerRole: "",
    category: "",
    batting: "",
    image: null,
    video: null,
  });

  useEffect(() => {
    const getStates = async () => {
      const req = await fetch(`${BASE_URL}core/state/`);
      const res = await req.json();
      setStates(res.data);

      // Store the state names in a separate object for easy lookup
      const stateNamesObj = {};
      res.data.forEach((state) => {
        stateNamesObj[state.id] = state.name;
      });
      setStateNames(stateNamesObj);
    };
    getStates();
  }, []);

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
  
    if (name === "state") {
      try {
        const selectedState = states.find((state) => state.id.toString() === value);
        if (selectedState) {
          setStatename(selectedState.id);
          setFormValues({
            ...formValues,
            state: selectedState.name, // Set the state name, not the ID
            district: "", // Reset the district when a new state is selected
          });
        } else {
          setStatename("");
          setFormValues({
            ...formValues,
            state: "", // Reset the state if no valid state is selected
            district: "", // Reset the district when no valid state is selected
          });
        }
  
        const res = await fetch(`${BASE_URL}core/district/?state_id=${value}`);
        const data = await res.json();
        setDistricts(data.data);
      } catch (error) {
        console.error(error);
      }
    } else {
      // For other input fields, update the form values as usual
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  
  

  const [imageBase64, setImageBase64] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState("");
  const [videoBase64, setVideoBase64] = useState(null);
  const [selectedVideoName, setSelectedVideoName] = useState("");

  const handleImageChange = async (event) => {
    const image = event.target.files[0];
    setFormValues({ ...formValues, image });

    if (image) {
      setSelectedImageName(image.name);

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        setImageBase64(reader.result);
      };
    } else {
      setSelectedImageName("");
      setImageBase64(null);
    }
  };
  const handleVideoChange = async (event) => {
    const video = event.target.files[0];

    const maxDuration = 61; // 1 minute in seconds
    const videoPlayer = document.createElement("video");
    videoPlayer.preload = "metadata";
    videoPlayer.onloadedmetadata = () => {
      if (videoPlayer.duration > maxDuration) {
        setErrors({
          ...errors,
          video: `Please upload a video that is less than 60 seconds.`,
        });
      } else {
        setErrors({});
        const reader = new FileReader();
        reader.readAsDataURL(video);
        reader.onload = () => {
          setFormValues({ ...formValues, video });
          setSelectedVideoName(video.name);
          setVideoBase64(reader.result);
        };
      }
    };
    videoPlayer.src = URL.createObjectURL(video);
  };

  var handleBack = () => {
    setActiveStep(activeStep - 1);
    setErrors({});
  };

  const handlefullNameInputChange = (event) => {
    const limit = 30;
    setFormValues({
      ...formValues,
      fullName: event.target.value.replace(/[^a-zA-Z\s]/gi, "").slice(0, limit),
    });
  };

  const handlemobileNumberInputChange = (event) => {
    const limit = 10;
    const reg = /^[0-9\b]+$/;
  
    if (
      event.target.value === "" ||
      (reg.test(event.target.value) && event.target.value[0] !== "0")
    ) {
      setFormValues({
        ...formValues,
        mobileNumber: event.target.value.slice(0, limit),
      });
    }
  };

  const [errors, setErrors] = useState({
    fullName: "",
    mobileNumber: "",
    dateofBirth: "",
    schoolName: "",
    state: "",
    district: "",
    mandal: "",
    email: "",
    palyerRole: "",
    category: "",
    batting: "",
    image: "",
    video: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [valid, setValid] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    ReactGA.event({
      category: 'User Form submit',
      action: 'Button Click',
      label: 'Form Submit Button'
    });
    event.preventDefault();
    const data = {
      full_name: formValues.fullName,
      date_of_birth: formValues.dateofBirth,
      email: formValues.email,
      school_name: formValues.schoolName,
      playing_role: formValues.palyerRole,
      batting_style: formValues.batting,
      bowling_style: formValues.category,
      state: stateNames[statename],
      district: formValues.district,
      address: formValues.address,
      mobile: formValues.mobileNumber,
      // photo: imageBase64,
      video: videoBase64,
    };
    if (imageBase64) {
      data.photo = imageBase64;
    }

    // console.log(data); // log the fetched data
    const token = localStorage.getItem("token") || "";

    // show loader
    setIsLoading(true);
    // console.log("form data", formValues); // log the form values to submit data

    fetch(`${BASE_URL}students/create/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((resp) => resp.json())
      .then((data) => {
        // console.log("Server response:", data);

        setValid(true);
        // navigate(`/payment/${data.data?.id}`);
        // redirectPaymentPage(data.data);
        navigate(`/ease-buzz/${data.data?.id}`, { state: data.data });
        // hide loader after 2 seconds
        setTimeout(() => setIsLoading(false), 2000);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);

        // hide loader
        setIsLoading(false);
      });
  };

  const steps = [
    {
      label: "Step 1",
      className: "Label_steps",
      component: (
        <div className="StepOneInputs">
          <div className="Form_inputs">
            <div className="Form_subinputs">
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  id="fullName"
                  type="text"
                  value={formValues.fullName}
                  onChange={handlefullNameInputChange}
                  maxLength="50"
                  minLength="3"
                  autoComplete="off"
                  required
                />
                {errors.fullName && <p>{errors.fullName}</p>}
                <label htmlFor="fullName">Full Name</label>
              </div>
              {/* --------------------------------------- */}
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  id="MobileNumber"
                  type="tel"
                  value={formValues.mobileNumber}
                  onChange={handlemobileNumberInputChange}
                  minLength="10"
                  maxLength="10"
                  autoComplete="off"
                  required
                />
                {errors.mobileNumber && <p>{errors.mobileNumber}</p>}
                <label htmlFor="MobileNumber">Mobile Number</label>
              </div>
            </div>
            {/* --------------------------------------- */}
            <div className="Form_subinputs">
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  id="email"
                  type="email"
                  value={formValues.email}
                  onChange={(e) =>
                    setFormValues({ ...formValues, email: e.target.value })
                  }
                  required
                />
                {errors.email && <p>{errors.email}</p>}
                <label htmlFor="email">Email</label>
              </div>
              {/* --------------------------------------- */}
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  id="DateofBirth"
                  type="date"
                  value={formValues.dateofBirth}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      dateofBirth: e.target.value,
                    })
                  }
                  min="1900-01-01"
                  max={`${new Date().getFullYear()}-01-01`}
                  required
                />

                <h6 className="Date_of_Birth-eligibility">
                  Eligibility : Your age must be between 12 to 16 years old to
                  register
                </h6>
                {errors.dateofBirth && <p>{errors.dateofBirth}</p>}
                <label htmlFor="DateofBirth">Date of Birth</label>
              </div>
            </div>
            {/* --------------------------------------- */}
            <div className="Form_subinputs">
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  type="text"
                  id="schoolName"
                  value={formValues.schoolName}
                  onChange={(e) =>
                    setFormValues({ ...formValues, schoolName: e.target.value })
                  }
                  required
                  maxLength="50"
                  minLength="3"
                  autoComplete="off"
                />

                {errors.schoolName && <p>{errors.schoolName}</p>}
                <label htmlFor="schoolName">School Name</label>
              </div>
              {/* --------------------------------------- */}
              <div className="form-item">
                <input
                  className="Input_Fileds"
                  id="address"
                  type="text"
                  value={formValues.address}
                  onChange={(e) =>
                    setFormValues({ ...formValues, address: e.target.value })
                  }
                  required
                  maxLength="100"
                  minLength="3"
                  autoComplete="off"
                />
                {errors.address && <p>{errors.address}</p>}
                <label htmlFor="address">Address</label>
              </div>
            </div>
            {/* --------------------------------------- */}
            <div className="Form_subinputs">
              <div className="Selected_tags_errors">
        
             <select
  required
  name="state"
  id="state"
  value={statename} // Set the value to formValues.state
  onChange={handleInputChange}
  defaultValue=""
>
  <option value="" disabled hidden>
    Select State
  </option>
  {states &&
    states.map((state) => (
      <option key={state.id} value={state.id} >
        {state.name}
      </option>
    ))}
</select>
                {errors.state && <p>{errors.state}</p>}
              </div>
              {/* --------------------------------------- */}
              <div className="Selected_tags_errors">
                {/* <label className="lableSelect" for="select-input">
 Select District:{" "}
 </label> */}
                <select
                  required
                  name="district"
                  id="district"
                  value={formValues.district}
                  onChange={handleInputChange}
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Select District
                  </option>
                  {districts &&
                    districts.map((district) => (
                      <option key={district.id} value={district.name}>
                        {district.name}
                      </option>
                    ))}
                </select>
                {errors.district && <p>{errors.district}</p>}
              </div>
            </div>
            {/*---------------------------------------*/}
          </div>
        </div>
      ),
    },

    //-------------------Step 2-----------------------
    //-------------------Step 2-----------------------
    //-------------------Step 2-----------------------
    {
      label: "Step 2",
      className: "Label_steps",
      component: (
        <div className="Step2-inputs">
          <div className="Form_inputs">
            <div className="Form_subinputs">
              <div className="Selected_tags_errors">
                               <select
                  name="bowlingstyle"
                  required
                  value={formValues.palyerRole}
                  onChange={(e) =>
                    setFormValues({ ...formValues, palyerRole: e.target.value })
                  }
                  defaultValue=""
                >
                  <option value="" disabled>
                    Select Player Role
                  </option>
                  <option value="Batsman">Batsman</option>
                  <option value="Bowler">Bowler</option>
                </select>
                {errors.palyerRole && <p>{errors.palyerRole}</p>}
              </div>

              {/* --------------------------------------- */}
              <div className="Selected_tags_errors">
                <select
                  name="bowlingstyle"
                  required
                  value={formValues.batting}
                  onChange={(e) =>
                    setFormValues({ ...formValues, batting: e.target.value })
                  }
                  defaultValue=""
                >
                  <option value="" disabled>
                    Select Batting Style
                  </option>
                  <option value="Right hand">Right Handed</option>
                  <option value="Left hand">Left Handed</option>
                </select>
                {errors.batting && <p>{errors.batting}</p>}
              </div>
              {/* --------------------------------------- */}
              <div className="Selected_tags_errors">
             

                <option value="" disabled hidden>
                  Select Bowling Style
                </option>
                <select
                  required
                  value={formValues.category}
                  onChange={(e) =>
                    setFormValues({ ...formValues, category: e.target.value })
                  }
                  defaultValue=""
                >
                  <option value="" disabled>
                    Select Bowling Style
                  </option>
                  <option value="Fastbowling">Fast bowling</option>
                  <option value="Swingbowling">Swing bowling</option>
                  <option value="Seambowling">Seam bowling</option>
                  <option value="Spinbowling">Spin bowling</option>
                  <option value="Off-spinbowling">Off-spin bowling</option>
                  <option value="Leg-spin bowling">Leg-spin bowling</option>
                </select>
                {errors.category && <p>{errors.category}</p>}
              </div>
              {/* --------------------------------------- */}
            </div>

            {/* ------------------Image & video Uploading--------------------- */}
            {/* ------------------Image & video Uploading--------------------- */}
            <div className="Images_Uploading">
              <div className="file-input-container">
                <label htmlFor="image-input" className="file-input-label">
                  <div className="file-input-icon">
                    <i className="fa-solid fa-circle-arrow-up" />
                    <i />
                  </div>
                  <div className="file-input-text">
                    {selectedImageName ? selectedImageName : "Upload image"}
                  </div>
                </label>
                <input
                  id="image-input"
                  type="file"
                  className="file-input"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                {errors.image && <p>{errors.image}</p>}
              </div>
              {/* --------------------------------------- */}

              <div className="file-input-container">
                <label htmlFor="video-input" className="file-input-label">
                  <div className="file-input-icon">
                    <i className="fa-solid fa-circle-arrow-up" /> <i />
                    <div className="file-input-text">
                      {selectedVideoName
                        ? selectedVideoName
                        : "Upload your one minute video"}
                    </div>
                  </div>
                </label>
                <input
                  id="video-input"
                  type="file"
                  className="file-input"
                  accept="video/*"
                  onChange={handleVideoChange}
                />
                {errors.video && <p>{errors.video}</p>}
              </div>
            </div>
            {/* ----------------End of Section Image and video----------------------- */}
            {/* ----------------End of Section Image and video----------------------- */}
          </div>
        </div>
      ),
    },
    {
      label: "Step 3",
      component: (
        <form className="step3Preview" onSubmit={handleSubmit}>
          <div className="preview_Section">
            <h2>PREVIEW DATA OF YOUR DETAILS</h2>

            <div className="PlayerDetails-preview1">
              <div className="player-dts-left">
                <div className="detailsPreview-1">
                  <div className=" Imagepreview22">
                    {imageBase64 && <img src={imageBase64} alt="Preview" />}
                  </div>
                  <div className="VideoPreview22">
                    {videoBase64 && (
                      <video
                        src={videoBase64}
                        max-duration="61"
                        controls
                        style={{ maxWidth: "100%" }}
                      />
                    )}
                  </div>
                </div>

                <div className="Player-personal-details">
                  {/* ----------------style-2---------END-----------END---------------- */}

                  {/* ----------------------style4------style4----------------------------- */}
                  <div className="form-preview-data">
                    <div className="p-left-d">
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Full Name</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.fullName}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Date of Birth</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;
                          <h4>{formValues.dateofBirth}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Mobile Number</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;
                          <h4>+91 {formValues.mobileNumber}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Email</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.email}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>School Name</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.schoolName}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="p-right-d">
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Player Role</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.palyerRole}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Batting Style</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.batting}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Bowling Style</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.category}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>State</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{stateNames[statename]}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>District</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.district}</h4>
                        </div>
                      </div>
                      <div className="label-name-card">
                        <div className="name-field-static">
                          <h4>Address</h4>
                        </div>
                        <div className="name-field-dynamic">
                          <h4>:</h4>&nbsp;&nbsp;<h4>{formValues.address}</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ------------END----------style4------style4------------END----------------- */}
                </div>
              </div>
            </div>
          </div>
        </form>
      ),
    },
  ];

  const handleNext = () => {
    const newErrors = validateFields(formValues, activeStep);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      // Check if the video field exists and its duration is less than or equal to 1 minute
      if (formValues.video) {
        const maxDuration = 61; // 1 minute in seconds
        const videoPlayer = document.createElement("video");
        videoPlayer.preload = "metadata";
        videoPlayer.src = URL.createObjectURL(formValues.video);
        videoPlayer.onloadedmetadata = () => {
          if (videoPlayer.duration > maxDuration) {
            setErrors({
              ...errors,
              //  video: `Please upload a video that is less than ${maxDuration} seconds.`,
              video: `Please upload a video that should not be greater than 60 seconds.`,
            });
          } else {
            navigateToNextStep();
          }
        };
      } else {
        navigateToNextStep();
      }
    }
  };

  // Extracted function for navigating to the next step
  const navigateToNextStep = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
      setErrors({});
    } else {
      setSubmitted(true);
    }
  };

  const validateFields = (values, step) => {
    const errors = {};
    if (step === 0) {
      if (!values.fullName) {
        errors.fullName = "Please enter a name";
      }

      if (!values.mobileNumber) {
        errors.mobileNumber = "Please enter Mobile Number";
      }
      if (!values.dateofBirth) {
        errors.dateofBirth = "Please enter Date of Birth";
      } else {
        const birthYear = new Date(values.dateofBirth).getFullYear();
        const currentYear = new Date().getFullYear();
        const age = currentYear - birthYear;

        if (age < 12 || age > 16) {
          errors.dateofBirth =
            "Your age must be between 12 to 16 years old to register";
        }
      }
      // if (!values.schoolName) {
      // errors.schoolName = "Please enter School Name";
      // }
      if (!values.state) {
        errors.state = "Please select state";
      }
      if (!values.district) {
        errors.district = "Please select district";
      }
      // if (!values.address) {
      // errors.address = "Please enter address";
      // }
      if (!values.email) {
        errors.email = "Please enter an email";
      } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = "Please enter a valid email address";
      }
      // if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      //   errors.email = "Please enter a valid email address or leave as empty";
      // }
    } else if (step === 1) {
      if (!values.palyerRole) {
        errors.palyerRole = "Please select Player Role";
      }
      if (!values.category) {
        errors.category = "Please select a bowling Style";
      }
      if (!values.batting) {
        errors.batting = "Please select a batting style";
      }

      if (!values.video) {
        errors.video = "Please upload a video";
      } else if (values.video.duration > 61) {
        errors.video = "Video duration should be less than 1 minute";
      }
      // if (!values.image) {
      // errors.image = "Please upload a photo";
      // }
    }
    return errors;
  };

  return (
    <div className="Form">
      <div className="Bg-Multi_steps">
        <ul className="Multi_steps">
          {steps.map((step, index) => (
            <li key={step.label} className="list_of_Steps">
              <button
                className="Button_multisteps"
                disabled={index > activeStep}
                onClick={() => setActiveStep(index)}
              >
                {step.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {steps[activeStep].component}
      <div className="Form-next-back-btn">
        <div className="Form_NextButton">
          {activeStep !== 0 && (
            <button
              onClick={handleBack}
              className="Button_multisteps formFooter-btn"
            >
              Back
            </button>
          )}
          {activeStep < steps.length - 1 ? (
            <button
              onClick={handleNext}
              className="Button_multisteps formFooter-btn"
            >
              Next
            </button>
          ) : (
            <>
              <button
                onClick={handleSubmit}
                type="submit"
                className="Button_multisteps formFooter-btn"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MultiHorizontalStepper;
